import styled from '@emotion/styled';

const ButtonPrimary = styled.button`
  display: inline-block;
  height: 34px;
  padding: 0 20px;
  color: #555;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 34px;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border-radius: 4px;
  border: 1px solid #bbb;
  cursor: pointer;
  box-sizing: border-box;
  background: white;
  margin: 0;
  margin: ${props => props.margin || 0};
  i {
    margin: 11px 3px 0 0;
  }

  &:disabled {
    cursor: default !important;
    color: #ccc;
  }
`;

export default ButtonPrimary;